import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const OwnerIdFragmentGql: DocumentNode = gql`
fragment OwnerIdFragment on TableauUser {
  id
  vizportalId
}
`;
